import { BooleanFeatureFlag } from "@me8eon/featureflags";

export const compassPersonalizationFFName = "compassPersonalization";
export const compassPersonalizationFeatureFlag: BooleanFeatureFlag = {
    value: false,
    description: "Enable Compass scope (business unit) selector in the prompt area",
};
